import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import CustomerList from './pages/CustomerList';
import CustomerForm from './pages/CustomerForm';
import BookingList from './pages/BookingList';
import BookingForm from './pages/BookingForm';

const App = () => {
  const token = localStorage.getItem('token'); 
  return (
    <Router>
      <Routes>
        <Route path="/" element={!token ? <LoginPage /> : <Navigate to="/dashboard" replace  />} />
        <Route path="/dashboard" element={<Dashboard />} /> 
        <Route path="/customers" element={<CustomerList />} />
        <Route path="/customers/new" element={<CustomerForm />} />
        <Route path="/customers/edit/:id" element={<CustomerForm />} />
        <Route path="/bookings" element={<BookingList />} />
        <Route path="/bookings/new" element={<BookingForm />} />
        <Route path="/bookings/edit/:id" element={<BookingForm editMode={true}/>} />
      </Routes>
    </Router>
  );
};

export default App;
